import { Box, Button, Grid, Typography } from "@mui/material";
import { AspectRatio } from "@mui/joy";
import { useNavigate } from "react-router-dom";
import data from "../../Assets/data/books.json";

const BooksContainer = () => {
  const navigate = useNavigate();
  return (
    <>
      <Box
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingBottom: "2em",
        }}
      >
        <Box
          style={{
            width: "100%",
            background:
              "linear-gradient(180deg, #004C98 0%, rgba(90, 139, 188, 0.646736) 38.69%, rgba(255, 255, 255, 0) 100%)",
          }}
        >
          <Typography
            style={{
              padding: "32px",
              width: "100%",
              justifyContent: "flex-end",
              display: "flex",
              boxSizing: "border-box",
              marginRight: "32px",
            }}
            fontSize="32px"
            fontWeight={600}
          >
            BOOKS
          </Typography>
        </Box>
        <Box
          style={{
            maxWidth: "960px",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid container>
            <Grid item xs={3}>
              <Box>
                <Typography
                  style={{ margin: "24px 0px" }}
                  fontSize="28px"
                  fontWeight={600}
                >
                  DIRECTORY
                </Typography>
              </Box>
              <Box>
                <Typography fontSize="18px" fontWeight={600} color="black">
                  Books
                </Typography>
                <Button
                  style={{ textTransform: "none", padding: "0px" }}
                  onClick={() => navigate("/publications")}
                >
                  <Typography fontSize="18px" fontWeight={600} color="black">
                    Back to Publications
                  </Typography>
                </Button>
              </Box>
            </Grid>
            <Grid item xs={9}>
              {data.map((book, i) => {
                return (
                  <Box
                    style={{
                      width: "100%",
                      background: "#003366",
                      padding: "32px",
                      borderRadius: "16px",
                      boxSizing: "border-box",
                      marginBottom: "12px",
                      cursor: "pointer",
                    }}
                    key={i}
                    onClick={() => {
                      navigate(`/publications/books/${book.url}`);
                    }}
                  >
                    <Grid container>
                      <Grid item xs={2}>
                        <AspectRatio ratio="9/15">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/Images/BookCover/" +
                              book.image
                            }
                            alt="Book cover"
                            style={{ width: "-webkit-fill-available" }}
                          />
                        </AspectRatio>
                      </Grid>
                      <Grid item xs={9}>
                        <Typography
                          color="white"
                          style={{ marginLeft: "12px" }}
                          fontSize="28px"
                          sx={{
                            display: "-webkit-box",
                            overflow: "hidden",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                          }}
                        >
                          {book.title}
                        </Typography>
                        <Typography
                          color="white"
                          style={{ marginLeft: "12px" }}
                          sx={{
                            display: "-webkit-box",
                            overflow: "hidden",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 3,
                          }}
                        >
                          {book.description
                            ? book.description
                            : "No Description"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                );
              })}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default BooksContainer;
